import { rangePresets } from '@gogame/intl-ts';

export const permission = 67;
export const SCREEN_NAME = 'ad-tracker';

//filters
export const FILTER_DATE = 'date';
export const FILTER_APPLICATIONS = 'applications'; // api/applications
export const FILTER_NETWORKS = 'networks'; // /api/networks
export const FILTER_PLATFORMS = 'platforms'; // /api/platforms
export const FILTER_CLUSTERS = 'clusters'; // /api/platforms
export const FILTER_TRAFFIC_TYPE = 'trafficType';
export const FILTER_TIME_ZONE = 'timeZone';
export const FILTER_COUNTRIES = 'countryIds';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_OWNERS = 'ownerIds';
export const FILTER_MANAGERS = 'managerIds';

//columns
export const COLUMN_DIMENSION = 'Dimension';
export const COLUMN_REGS = 'TotalRegs';
export const COLUMN_DEPOSITS = 'TotalDeposits';
export const COLUMN_SUBSCRIPTIONS = 'Subscriptions';
export const COLUMN_FREE_TRIALS = 'DepositFreeTrials';
export const COLUMN_DEPOSIT_AMOUNT = 'TotalDepositAmount';
export const COLUMN_DEPOSIT_AMOUNT_GROSS = 'TotalDepositAmountGrossUsd';

export const PERIOD_PRESETS = [rangePresets.TODAY, rangePresets.YESTERDAY];

export const FILTER_TITLES = {
  applications: 'Applications',
  networks: 'Networks',
  platforms: 'Platforms',
  clusters: 'Clusters',
  trafficType: 'Traffic',
  timeZone: 'Time Zone',
  countries: 'Countries',
  affiliates: 'Affiliates',
  owners: 'Owners',
  managers: 'Managers',
};
